import { createFileRoute } from '@tanstack/react-router';

import { BusinessAssociateListScreen } from '@/features/business-associates/components/platform/BusinessAssociateListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/business-associates/')({
  beforeLoad: () => {
    requirePermission('ba:read');
  },
  component: BusinessAssociateListScreen,
  staticData: { crumb: 'Business Associates' },
});
